// app/stores/useRegisterStore.ts
import {defineStore} from 'pinia'
import {reactive, ref} from 'vue'
import {z} from 'zod'
import {
    step0Schema,
    step1Schema,
    step2Schema,
    step3Schema,
    fullFormSchema
} from "~/utils/registerSchemas";

export const useRegisterStore = defineStore('register', () =>
    {
        const currentStep = ref<number>(0)

        // Estado centralizado
        const initialState = {
            username: '',
            email: '',
            confirmEmail: '',
            password: '',
            confirmPassword: '',
            acceptedTerms: false,
            name: '',
            surname: '',
            birthDate: '',
            isStudent: '',
            howMeet: '',
            country: 'Brasil',
            state: '',
            city: '',
            nationality: 'Brasileiro',
            cpf: '',
            residents: '',
            income: '',
            race: 'Preta'
        }

        const state = reactive({...initialState})

        const resetState = () => {
            Object.assign(state, initialState)
            currentStep.value = 0
        }

        // Computed property para injetar o schema correto no Stepper
        const currentSchema = computed(() => {
            const schemas = [step0Schema, step1Schema, step2Schema, step3Schema]
            // Retorna o schema correspondente ao passo, ou o fullFormSchema se algo falhar
            return schemas[currentStep.value] || fullFormSchema
        })

        // Ações
        const nextStep = (isValid: boolean) => {
            if (isValid) {
                currentStep.value++
            }
        }

        const prevStep = () => {
            if (currentStep.value > 0) currentStep.value--
        }

        const submitRegister = async () => {
            const validation = fullFormSchema.safeParse(state)

            if (validation.success) {
                console.log('Cadastro pronto para envio (Validação Final Zod OK)', state)

                const uiStore = useUiStore()

                try {
                    // URL do seu Webhook de Produção ou Teste no N8N
                    const n8nWebhookUrl = 'https://suporte.ead.ifmg.edu.br/n8n/webhook/moodle-register'

                    // Envia o state diretamente como JSON
                    const response = await $fetch(n8nWebhookUrl, {
                        method: 'POST',
                        body: state
                    })

                    console.log('Cadastro enviado com sucesso via n8n!', response)
                    uiStore.closeAuthModal()

                    // TODO: Redirecionar o usuário ou mostrar mensagem de sucesso

                } catch (error) {
                    console.error('Erro ao enviar cadastro para o n8n:', error)
                    // TODO: Tratar o erro (ex: mostrar notificação Toast para o usuário)
                }
            }
        }

        return {state, currentStep, currentSchema, nextStep, prevStep, submitRegister, resetState}
    },
    {
        persist: {
            pick: ['state', 'currentStep']
        }
    }
)